import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowRight, Shield, Brain, BarChart3 } from 'lucide-react';
import { usePlans } from '@/contexts/PlanRulesContext';
import { PLAN_IDS } from '@/constants';
import { formatCurrency } from '@/helpers/formatters';

export default function CtaSection() {
  const navigate = useNavigate();

  const { plans, isLoadingPlans } = usePlans();
  const [basicPlan, setBasicPlan] = useState(null);


  useEffect(() => {

    if(!plans || isLoadingPlans) return;
    const foundBasicPlan = plans?.plans?.find(plan => plan.id === PLAN_IDS.PLAN_99);
    setBasicPlan(foundBasicPlan);

  }, [plans, isLoadingPlans])

  // const basicPlan = plans?.find(plan => plan.id === PLAN_IDS.PLAN_99);

  return (
    <section id="cta" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 hero-gradient" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-primary-dark/30" />

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-accent/20 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-64 h-64 bg-primary-light/20 rounded-full blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Badge
          variant="outline"
          className="mb-6 px-4 py-2 text-sm border-primary-foreground/30 text-primary-foreground/90 bg-primary-foreground/5 backdrop-blur-sm"
        >
          Start Optimizing Today
        </Badge>

        <p className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
          Ready to Maximize<br />
          <span className="text-accent-light">Your Hotel Revenue?</span>
        </p>

        <p className="text-lg sm:text-xl text-primary-foreground/80 mb-10 max-w-2xl mx-auto">
          Join hotels using Prowen to monitor rate parity, get AI-powered insights,
          and make smarter pricing decisions.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button
            variant="premium"
            size="xl"
            className="group"
            onClick={() => navigate('/register')}
          >
            Get Started Free
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Button>
          <Button
            variant="hero"
            size="xl"
            className="group"
            onClick={() => navigate('/login')}
          >
            Sign In to Dashboard
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </div>

        {/* Feature Highlights */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-primary-foreground/70">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4" />
            <span>Rate Parity Monitoring</span>
          </div>
          <div className="flex items-center gap-2">
            <Brain className="w-4 h-4" />
            <span>AI-Powered Insights</span>
          </div>
          <div className="flex items-center gap-2">
            <BarChart3 className="w-4 h-4" />
            <span>Competitive Analysis</span>
          </div>
        </div>

        {/* Trust Message */}
        <p className="mt-12 text-sm text-primary-foreground/50">
          {`${(!basicPlan) ? "" : `${basicPlan?.amount ? `Our lite plans start from ${formatCurrency(basicPlan?.amount,basicPlan?.currency)}` : ""}`} • No credit card required • Cancel anytime`}
        </p>
      </div>
    </section>
  );
}
